var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "header",
    { staticClass: "c-header", class: _vm.headerStyle },
    [
      _c("div", { staticClass: "c-header_container" }, [
        _c("div", { staticClass: "c-header_wrapper" }, [
          _c(
            "div",
            { staticClass: "c-header_menu" },
            [
              _c(_vm.activeMenu, {
                tag: "component",
                attrs: { "dark-mode": _vm.isDarkMode },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "c-header_popup" },
            [
              _c(
                "transition",
                { attrs: { name: _vm.desktopTransition } },
                [
                  _c(_vm.activeDesktop, {
                    key: `popup-${_vm.selectedName}`,
                    tag: "component",
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "c-header_slideout" },
            [
              _c(
                "transition",
                { attrs: { name: _vm.mobileTransition } },
                [
                  _c(_vm.activeMobile, {
                    key: `slideout-${_vm.selectedName}`,
                    tag: "component",
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "s-fade" } }, [
        _c("div", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.activeDesktop || _vm.activeMobile,
              expression: "activeDesktop || activeMobile",
            },
          ],
          staticClass: "c-header_backdrop",
          on: { click: _vm.closeAll },
        }),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }